import React, { Component } from "react";
import { Link } from "react-router-dom";
import axios from "../../utils/axiosInstance";
import MenuMain from "../../components/frontend/MenuMain";

class Cart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cart: [],
      currency_symbol: "",
    };
  }

  componentDidMount() {
    this.fetchFooterData();
    this.loadCart();
    window.addEventListener("cartUpdated", this.syncCart);
  }

  componentWillUnmount() {
    window.removeEventListener("cartUpdated", this.syncCart);
  }

  fetchFooterData = async () => {
    try {
      const res = await axios.get("/setting");
      const d = res?.data?.data;
      if (d) {
        this.setState({
          currency_symbol: d.currency_symbol || "",
        });
      }
    } catch (error) {
      console.error("Footer fetch error:", error);
    }
  };

  loadCart = () => {
    const cart = JSON.parse(localStorage.getItem("cart")) || [];
    this.setState({ cart });
  };

  syncCart = () => {
    const cart = JSON.parse(localStorage.getItem("cart")) || [];
    this.setState({ cart });
  };

  increaseQty = (id) => {
    const cart = this.state.cart.map((item) =>
      item.id === id ? { ...item, qty: item.qty + 1 } : item
    );

    localStorage.setItem("cart", JSON.stringify(cart));
    this.setState({ cart });
    window.dispatchEvent(new Event("cartUpdated"));
  };

  decreaseQty = (id) => {
    const cart = this.state.cart.map((item) =>
      item.id === id && item.qty > 1
        ? { ...item, qty: item.qty - 1 }
        : item
    );

    localStorage.setItem("cart", JSON.stringify(cart));
    this.setState({ cart });
    window.dispatchEvent(new Event("cartUpdated"));
  };

  removeFromCart = (id) => {
    const cart = this.state.cart.filter((item) => item.id !== id);
    localStorage.setItem("cart", JSON.stringify(cart));
    this.setState({ cart });
    window.dispatchEvent(new Event("cartUpdated"));
  };

  clearCart = () => {
    localStorage.removeItem("cart");
    this.setState({ cart: [] });
    window.dispatchEvent(new Event("cartUpdated"));
  };

  getSubtotal = () => {
    return this.state.cart.reduce(
      (total, item) => total + item.price * item.qty,
      0
    );
  };

  render() {
    const { cart, currency_symbol } = this.state;

    return (
      <>
        <MenuMain />

        <main className="main">
          {/* Breadcrumb */}
          <div className="page-header breadcrumb-wrap">
            <div className="container">
              <div className="breadcrumb">
                <Link to="/">
                  <i className="fi-rs-home mr-5" /> Home
                </Link>
                <span /> Shop <span /> Cart
              </div>
            </div>
          </div>

          {/* Content */}
          <div className="container mb-80 mt-50">
            <div className="row">
              <div className="col-lg-12 mb-40">
                <h1 className="heading-2 mb-10">Your Cart</h1>
                <div className="d-flex justify-content-between">
                  <h6 className="text-body">
                    There are{" "}
                    <span className="text-brand">{cart.length}</span> products in
                    your cart
                  </h6>
                  <h6 className="text-body">
                    <button
                      onClick={this.clearCart}
                      className="text-muted btn btn-link p-0"
                    >
                      <i className="fi-rs-trash mr-5" /> Clear Cart
                    </button>
                  </h6>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-12">
                <div className="table-responsive shopping-summery">
                  <table className="table table-wishlist">
                    <thead>
                      <tr className="main-heading">
                        <th>Sl.</th>
                        <th colSpan={2}>Product</th>
                        <th>Unit Price</th>
                        <th>Quantity</th>
                        <th>Subtotal</th>
                        <th className="end">Remove</th>
                      </tr>
                    </thead>

                    <tbody>
                      {cart.length === 0 ? (
                        <tr>
                          <td colSpan="7" className="text-center">
                            <h5>Your cart is empty 🛒</h5>
                          </td>
                        </tr>
                      ) : (
                        cart.map((item, index) => (
                          <tr key={item.id} className="pt-30">
                            <td>{index + 1}</td>

                            <td className="image product-thumbnail pt-40">
                              <img src={item.image} alt={item.name} />
                            </td>

                            <td className="product-des product-name">
                              <h6 className="mb-5">
                                <Link
                                  className="product-name mb-10 text-heading"
                                  to={`/product/${item.id}`}
                                >
                                  {item.name}
                                </Link>
                              </h6>
                            </td>

                            <td>
                              <h4 className="text-body">{currency_symbol}{item.price}</h4>
                            </td>

                            <td className="text-center">
                              <div className="detail-qty border radius">
                                <button
                                  className="qty-down"
                                  onClick={() => this.decreaseQty(item.id)}
                                >
                                  <i className="fi-rs-angle-small-down" />
                                </button>
                                <span className="qty-val">{item.qty}</span>
                                <button
                                  className="qty-up"
                                  onClick={() => this.increaseQty(item.id)}
                                >
                                  <i className="fi-rs-angle-small-up" />
                                </button>
                              </div>
                            </td>

                            <td>
                              <h4 className="text-brand">
                                {currency_symbol}{(item.price * item.qty).toFixed(2)}
                              </h4>
                            </td>

                            <td className="text-center">
                              <button
                                onClick={() => this.removeFromCart(item.id)}
                                style={{ background: "none", border: "none" }}
                              >
                                <i className="fi-rs-trash" />
                              </button>
                            </td>
                          </tr>
                        ))
                      )}

                      {cart.length > 0 && (
                        <tr>
                          <td colSpan="5" className="text-end">
                            <h6 className="text-muted">Subtotal</h6>
                          </td>
                          <td colSpan="2">
                            <h4 className="text-brand text-end">
                              {currency_symbol}{this.getSubtotal().toFixed(2)}
                            </h4>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

                <div className="divider-2 mb-30" />

                <div className="cart-action d-flex justify-content-between">
                  <Link to="/" className="btn">
                    <i className="fi-rs-arrow-left mr-10" /> Continue Shopping
                  </Link>
                  <Link to="/checkout" className="btn">
                    Proceed To Checkout <i className="fi-rs-sign-out ml-15" />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </main>
      </>
    );
  }
}

export default Cart;
